module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block height"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_c('p', [_vm._v("Premie "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.betaaltermijn))]), _vm._v(" "), _c('a', {
    staticClass: "modal-button",
    attrs: {
      "role": "button",
      "data-toggle": "modal",
      "data-target": "#premie-modal"
    }
  }, [_vm._v("j")])]), _vm._v(" "), (_vm.premie != '') ? _c('p', [_vm._v("€ " + _vm._s(_vm.premie))]) : _vm._e(), _vm._v(" "), (_vm.premie == '') ? _c('p', [_vm._v("Momenteel niet beschikbaar")]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.produkttypenaam == 'auto' || _vm.produkttypenaam == 'motor' || _vm.produkttypenaam == 'bromfiets' || _vm.produkttypenaam == 'camper') ? _c('li', [_c('p', [_vm._v("No-claimkorting")]), _vm._v(" "), (_vm.noclaimkorting == ',00 %') ? _c('p', [_vm._v("0 %")]) : _c('p', [_vm._v(_vm._s(_vm.noclaimkorting))])]) : _vm._e(), _vm._v(" "), (_vm.bonusmalus) ? _c('li', [_c('p', [_vm._v("Bonus/malus-trede")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bonusmalus))])]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Premie")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("Eigen risico")]), _vm._v(" "), _c('p', [_vm._v("Zie de polisvoorwaarden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "premie-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Premie")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n\t\t        Dit is de premie per termijn inclusief kosten en assurantiebelasting.\n\t\t      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89e39c4c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/premie.vue
// module id = 47
// module chunks = 0